import { useCallback, useState } from "react";
import { CreateListEmptyState } from "../../components/emptyStates/CreateListEmptyState.jsx";
import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { AssetSidebar } from "./components/AssetSidebar.jsx";
import { AssetDetailPanel } from "./components/AssetDetailPanel.jsx";
import { CreateAssetModal } from "./components/CreateAssetModal.jsx";

export function AssetManager({
  items,
  allItems,
  assetTypes,
  loading,
  search,
  setSearch,
  selected,
  selectedAssetType,
  selectedId,
  setSelectedId,
  addAsset,
  saveAsset,
  removeAsset,
  saving,
  getAssetTypeName,
  getAssetSubtitle,
  assetTypeMap,
  emptyHint,
  commandState,
}) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const openCreate = useCallback(() => {
    setEditing(null);
    setModalOpen(true);
  }, []);

  const openEdit = useCallback((asset) => {
    setEditing(asset);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setEditing(null);
  }, []);

  const handleSave = useCallback(async (payload) => {
    if (editing) {
      await saveAsset(editing.id, payload);
    } else {
      await addAsset(payload);
    }
  }, [editing, saveAsset, addAsset]);

  const showEmpty = !loading && allItems.length === 0;

  return (
    <>
      <div style={{ display: "flex", flex: 1, minHeight: 0, height: "100%" }}>
        <AssetSidebar
          assets={items}
          selectedId={selectedId}
          onSelect={setSelectedId}
          search={search}
          onSearchChange={setSearch}
          onCreate={openCreate}
          loading={loading}
          getAssetTypeName={getAssetTypeName}
          getAssetSubtitle={getAssetSubtitle}
          getAssetType={(assetTypeId) => assetTypeMap[assetTypeId] ?? null}
        />
        {showEmpty ? (
          <AssetsEmptyState onCreate={openCreate} hint={emptyHint} />
        ) : (
          <AssetDetailPanel
            asset={selected}
            assetType={selectedAssetType}
            onEdit={openEdit}
            onDelete={removeAsset}
            commandState={commandState}
          />
        )}
      </div>
      <CreateAssetModal
        open={modalOpen}
        onClose={closeModal}
        onSave={handleSave}
        editing={editing}
        saving={saving}
        assetTypes={assetTypes}
      />
    </>
  );
}

function AssetsEmptyState({ onCreate, hint }) {
  const { c, dark, accentHex: A } = useThemeSlice();

  return (
    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 0, padding: 24, background: c.bg }}>
      <CreateListEmptyState
        title="No assets yet"
        hint={hint}
        primaryAction={{ label: "Create asset", onClick: onCreate }}
        c={c}
        dark={dark}
        A={A}
      />
    </div>
  );
}
